import React, { useEffect, useState } from 'react';
import '../components/styles/alert.css';
import { AlertPosition, AlertType } from '../common/services/auth.types';


interface AlertProps {
  type?: AlertType;
  message?: React.ReactNode;
  title?: string;
  duration?: number;
  onClose?: () => void;
  show?: boolean;
  position?: AlertPosition;
}

const Alert: React.FC<AlertProps> = ({
  type = 'info',
  message,
  title,
  duration = 5000,
  onClose,
  show = true,
  position = 'top-right',
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(!!show);

  useEffect(() => {
    setIsVisible(!!show);
  }, [show]);

  useEffect(() => {
    if (duration && duration > 0) {
      const timer = window.setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer as number);
    }
    return undefined;
  }, [duration, onClose]);

  const handleClose = (): void => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  const getIcon = (): React.ReactNode => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`alert alert-${type} alert-${position}`}>
      <div className="alert-content">
        <div className="alert-icon">{getIcon()}</div>
        <div className="alert-body">
          {title && <h4 className="alert-title">{title}</h4>}
          <p className="alert-message">{message}</p>
        </div>
        <button className="alert-close" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default Alert; 